import styled from 'styled-components';

export const StyledDescriptionCell = styled.p`
   /* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
   display: -webkit-box;
   -webkit-line-clamp: 3;
   -webkit-box-orient: vertical;
   /* stylelint-enable value-no-vendor-prefix, property-no-vendor-prefix */
   overflow: hidden;
   grid-row: 1/-1;
   overflow-wrap: break-word;
   width: 100%;
`;

StyledDescriptionCell.displayName = 'StyledDescriptionCell';
